import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import axios from "axios";
import { Lock, ArrowRight, Loader2 } from "lucide-react";
import useSeo from "../hooks/useSeo";

const API = process.env.REACT_APP_BACKEND_URL;

export default function EmployeeChangePasswordPage() {
  useSeo({ title: "Skift password · EMA Kurer", path: "/employee/skift-password" });
  const navigate = useNavigate();
  const [current, setCurrent] = useState("");
  const [next, setNext] = useState("");
  const [confirm, setConfirm] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const token = localStorage.getItem("ema_employee_token");

  const onSubmit = async (e) => {
    e.preventDefault();
    if (next.length < 10) {
      toast.error("Nyt password skal være mindst 10 tegn");
      return;
    }
    if (next !== confirm) {
      toast.error("Passwords matcher ikke");
      return;
    }
    setSubmitting(true);
    try {
      await axios.post(
        `${API}/api/employee/change-password`,
        { current_password: current, new_password: next },
        { headers: { Authorization: `Bearer ${token}` } },
      );
      toast.success("Password opdateret");
      navigate("/employee");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Fejl ved opdatering");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="min-h-screen bg-brand-dark text-white flex items-center justify-center px-5" data-testid="employee-change-pw-page">
      <div className="w-full max-w-md">
        <h1 className="font-display font-bold text-3xl mb-3 text-center">Skift password</h1>
        <p className="text-white/60 text-sm text-center mb-6">Vælg et stærkt password (min. 10 tegn) før du fortsætter.</p>
        <form onSubmit={onSubmit} className="bg-white/[0.04] border border-white/10 p-7 space-y-5" data-testid="employee-change-pw-form">
          <PwField label="Nuværende (midlertidigt) password" v={current} setV={setCurrent} testid="employee-current-pw"/>
          <PwField label="Nyt password" v={next} setV={setNext} testid="employee-new-pw"/>
          <PwField label="Bekræft nyt password" v={confirm} setV={setConfirm} testid="employee-confirm-pw"/>
          <button type="submit" disabled={submitting} data-testid="employee-change-pw-submit" className="w-full bg-brand-red hover:bg-brand-red/90 text-white py-3 font-bold tracking-wider uppercase text-sm transition flex items-center justify-center gap-2 disabled:opacity-50">
            {submitting ? <Loader2 className="animate-spin" size={16}/> : <>Skift password <ArrowRight size={16}/></>}
          </button>
        </form>
      </div>
    </div>
  );
}

function PwField({ label, v, setV, testid }) {
  return (
    <div>
      <label className="block text-xs font-bold tracking-widest uppercase text-white/60 mb-2"><Lock size={12} className="inline mr-1.5"/> {label}</label>
      <input type="password" required value={v} onChange={(e) => setV(e.target.value)} data-testid={testid}
             className="w-full bg-brand-dark border border-white/15 px-4 py-3 text-white focus:border-brand-red focus:outline-none"/>
    </div>
  );
}
